module.exports = __webpack_public_path__ + "img/credit_card.280adb51.svg";